(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('ParameterizationDocsService', ParameterizationDocsService);

    ParameterizationDocsService.$inject = ['$http'];

    function ParameterizationDocsService($http) {
        var service = {
            getFullDocumentation: getFullDocumentation,
            getActionDefinitions: getActionDefinitions,
            getCommunicationDefinitions: getCommunicationDefinitions,
            getParameterResolution: getParameterResolution,
            getDefinitionSummaries: getDefinitionSummaries,
            getDefinitionSteps: getDefinitionSteps,
            getStepResolution: getStepResolution
        };

        return service;

        function getFullDocumentation() {
            return $http.get('/api/parameterization-docs').then(function(response) {
                return response.data;
            });
        }

        function getActionDefinitions() {
            return $http.get('/api/parameterization-docs/action-definitions').then(function(response) {
                return response.data;
            });
        }

        function getCommunicationDefinitions() {
            return $http.get('/api/parameterization-docs/communication-definitions').then(function(response) {
                return response.data;
            });
        }

        function getParameterResolution() {
            return $http.get('/api/parameterization-docs/parameter-resolution').then(function(response) {
                return response.data;
            });
        }

        function getDefinitionSummaries(search, page, size) {
            return $http.get('/api/parameterization-docs/definition-summaries', {
                params: {
                    search: search || '',
                    page: page || 0,
                    size: size || 20,
                    sort: 'description,asc'
                }
            }).then(function(response) {
                return {
                    data: response.data,
                    totalCount: parseInt(response.headers('X-Total-Count'), 10) || 0
                };
            });
        }

        function getDefinitionSteps(definitionId) {
            return $http.get('/api/parameterization-docs/definitions/' + definitionId + '/steps').then(function(response) {
                return response.data;
            });
        }

        function getStepResolution(stepId) {
            return $http.get('/api/parameterization-docs/steps/' + stepId + '/resolution').then(function(response) {
                return response.data;
            });
        }
    }
})();
